import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const Impressum = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-indigo-50 p-4 pt-24">
            <div className="max-w-4xl mx-auto">
                <Link
                    to="/"
                    className="inline-flex items-center text-gray-600 hover:text-indigo-600 mb-6 transition-colors"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Zurück zur Startseite
                </Link>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/60 p-8 md:p-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <FileText className="w-8 h-8 text-indigo-600" />
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Impressum</h1>
                    </div>

                    <div className="prose prose-indigo max-w-none text-gray-700 space-y-4">
                        <p><strong>Angaben gemäß § 5 ECG (Österreich)</strong></p>

                        <p>
                            <strong>Anbieter der Plattform „Studytino“:</strong><br />
                            Arda Alici<br />
                            Klosterweg 27<br />
                            6600 Reutte<br />
                            Österreich
                        </p>

                        <p>
                            <strong>Kontakt:</strong><br />
                            E-Mail: <a href="mailto:tynorra00@gmail.com" className="text-indigo-600 hover:underline">tynorra00@gmail.com</a>
                        </p>

                        <p>
                            <strong>Umsatzsteuer:</strong><br />
                            Gemäß § 6 Abs. 1 Z 27 UStG wird keine Umsatzsteuer berechnet.
                        </p>

                        <p>
                            <strong>Haftungshinweis:</strong><br />
                            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                        </p>

                        <p>
                            <strong>Streitschlichtung:</strong><br />
                            Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </p>

                        <p className="text-sm text-gray-500 mt-8">Stand: Juli 2026</p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Impressum;